<section class="py-3 card expenses-section card-div">
  <div class="container-fluid d-flex flex-column h-100">

    <div class="sticky-top-container">

      <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-5 d-flex flex-column align-items-start header-left">
          <div class="sku-badge px-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">Expenses</h2>
          </div>
          <span class="footer-text text-muted small">
            {{ selectedDateRangeText }} &middot; {{ selectedBranchText }} &middot; {{ highlights.entire }} entries
          </span>
        </div>

        <!-- Right Controls Div (col-md-7) -->
        <div
          class="col-12 col-md-7 d-flex align-items-center gap-2 justify-content-start justify-content-md-end flex-wrap header-right">

          <button class="btn period-btn d-flex align-items-center gap-2 py-2 px-3" (click)="openCalendar()">
            <fa-icon [icon]="faCalendarDays" class="text-muted icon-sm"></fa-icon>
            <span>{{ selectedDateRangeText }}</span>
          </button>

          @if (isBranchVisible) {
          <div class="branch-select-wrapper">
            <ng-select [items]="branches" bindLabel="name" bindValue="_id" [(ngModel)]="filters.company"
              [clearable]="false" placeholder="All Branches" (change)="onFilterChange()" class="custom-ng-select">
              <ng-template ng-label-tmp let-item="item">
                <fa-icon [icon]="faBuilding" class="text-muted me-2 icon-sm"></fa-icon>
                <span>{{ item.name }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="selected-text">{{ item.name }}</span>
              </ng-template>
            </ng-select>
          </div>
          }

          <button class="btn add-btn py-2 px-3 d-flex align-items-center gap-2" (click)="openExpenseDetail()">
            <fa-icon [icon]="faPlus" class="icon-sm"></fa-icon>
            <span class="fw-bold">Add Expense</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Highlights Cards Section -->
    <div class="row g-3 mb-4">
      <!-- Total Expenses Card -->
      <div class="col-12 col-md-4">
        <div class="highlight-card h-100 bg-white">
          <div class="card-top-label">Total Expenses</div>
          <div class="card-value py-1 text-truncate">₹{{ highlights.total | number }}</div>
          <div class="card-footer-label">{{ selectedDateRangeText }}</div>
        </div>
      </div>

      <!-- Entries Card -->
      <div class="col-12 col-md-4">
        <div class="highlight-card h-100 bg-white">
          <div class="card-top-label">Entries</div>
          <div class="card-value py-1 text-truncate">{{ highlights.entire | number}}</div>
          <div class="card-footer-label">Avg ₹{{ highlights.avgEntire | number }} / entry</div>
        </div>
      </div>

      <!-- Top Category Card -->
      <div class="col-12 col-md-4">
        <div class="highlight-card h-100 bg-white">
          <div class="card-top-label">Top Category</div>
          <div class="card-value py-1 text-truncate">{{ highlights.topCategory || '-' }}</div>
          <div class="card-footer-label">{{ highlights.topCategoryFooter || '-' }}</div>
        </div>
      </div>
    </div>

    <!-- Bottom Filter Card -->
    <div class="filter-card bg-white mb-4">
      <div class="d-flex flex-wrap align-items-center gap-3">

        <!-- Date Range Display Card -->
        <div class="custom-date-card bg-white cursor-pointer" (click)="openCalendar()">
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex flex-column align-items-start">
              <span class="date-label">FROM</span>
              <span class="date-val">{{ formatDate(filters.created_datefrom) }}</span>
            </div>
            <div class="arrow-container text-muted d-flex align-items-center">
              <fa-icon [icon]="faArrowRight" class="icon-sm"></fa-icon>
            </div>
            <div class="d-flex flex-column align-items-start">
              <span class="date-label">TO</span>
              <span class="date-val">{{ formatDate(filters.created_dateupto) }}</span>
            </div>
          </div>
        </div>

        <!-- Search Expenses input -->
        <div class="search-input-wrapper position-relative flex-grow-1">
          <input type="text" class="form-control filter-search" placeholder="Search expenses..."
            [value]="filters.description" #searchVal (input)="onSearchInput(searchVal.value)">
          <fa-icon [icon]="faSearch"
            class="position-absolute start-0 top-50 translate-middle-y ms-3 search-icon text-muted"></fa-icon>
        </div>

        <!-- Category ng-select -->
        <div class="category-select-wrapper">
          <ng-select [items]="categories" bindLabel="name" bindValue="_id" [(ngModel)]="filters.category_in"
            [multiple]="true" [closeOnSelect]="false" [clearable]="true" [searchable]="false" (scrollToEnd)="scroolCategories()"
            placeholder="All Categories" (change)="onFilterChange()" class="custom-ng-select custom-multi-select">
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              @if (items.length > 0) {
              <div class="ng-value custom-selected-badge">
                <span class="ng-value-label selected-text">{{items.length}} Selected</span>
              </div>
              }
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="d-flex align-items-center gap-2 py-1">
                <input type="checkbox" [checked]="item$.selected" class="form-check-input m-0 cursor-pointer" />
                <span class="ms-1 ng-option-text selected-text">{{item.name}}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <!-- Payment Mode ng-select -->
        <div class="payment-select-wrapper">
          <ng-select [items]="paymentTypes" bindLabel="label" bindValue="key" [(ngModel)]="filters.paymentMode"
            [clearable]="false" placeholder="All Payment Modes" (change)="onFilterChange()" class="custom-ng-select">
            <ng-template ng-label-tmp let-item="item">
              <fa-icon [icon]="faCreditCard" class="text-muted me-2 icon-sm"></fa-icon>
              <span>{{ item.label }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="selected-text">{{ item.label }}</span>
            </ng-template>
          </ng-select>
        </div>

      </div>
    </div>

    <!-- Table Section -->
    <div class="flex-grow-1 table-box-wrapper" style="min-height: 0;">
      <div class="card rounded-4 thick-border-gray shadow-none h-100">
        <div class="table-responsive h-100" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="500" (scrolled)="onScrollTable()">
          <table class="table custom-table align-middle m-0">
            <thead>
              <tr>
                <th class="fw-semibold">Exp ID</th>
                <th class="fw-semibold">Notes</th>
                <th class="fw-semibold">Category</th>
                <th class="fw-semibold">Branch</th>
                <th class="fw-semibold">Amount</th>
                <th class="fw-semibold text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <!-- Data grouped by Day -->
              @for (group of groupedExpenses; track group.dateKey) {
              <!-- Group Header Row -->
              <tr class="table-group-header">
                <td colspan="6">
                  <div class="d-flex justify-content-between align-items-center py-1">
                    <span class="group-date fw-semibold">{{ group.dateLabel }}</span>
                    <span class="group-summary">
                      {{ group.entriesCount }} {{ group.entriesCount === 1 ? 'entry' : 'entries' }} &middot; ₹{{
                      group.totalAmount | number }}
                    </span>
                  </div>
                </td>
              </tr>
              <!-- Group Entries -->
              @for (item of group.items; track item._id) {
              <tr class="normal-row cursor-pointer hover-bg-light" (click)="openExpenseDetail(item)">
                <td class="exp-id font-monospace">
                  {{ item.expId }}
                </td>
                <td>
                  <div class="note-main">{{ item.description || item.notes || '-' }}</div>
                  <div class="note-sub mt-1">
                    {{ item.paymentMode }}
                    @if (item.paymentMode && item.paymentAccount?.accountName) {
                    <span>&middot;</span>
                    }
                    {{ item.paymentAccount?.accountName }}
                  </div>
                </td>
                <td>
                  <span class="name-badge" [ngStyle]="getBadgeStyle(item.category)">{{ item.category?.name ||
                    item.categoryName || '-' }}</span>
                </td>
                <td class="table-text-branch">
                  {{ item.company?.name || item.branchName || '-' }}
                </td>
                <td class="table-text-amount">
                  ₹{{ item.amount | number }}
                </td>
                <td class="text-center action-cell">
                  <a class="btn app-btn-primary btn-sm" (click)="openExpenseDetail(item); $event.stopPropagation()">
                    <fa-icon [icon]="faEye" data-bs-toggle="tooltip" ngbTooltip="View details" [placement]="'top'"></fa-icon>
                  </a>
                </td>
              </tr>
              }
              }

              <!-- Loader Row -->
              @if (loader) {
              <tr>
                <td colspan="6" class="text-center py-4">
                  <app-loader [loadingIcon]="loader"></app-loader>
                </td>
              </tr>
              }

              <!-- Empty State Row -->
              @if (!loader && expensesList.length === 0) {
              <tr>
                <td colspan="6" class="text-center py-5 text-muted small">
                  No expenses data matches the selected filters.
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</section>